<div class="flex-row justify-content-space-between align-items-center">
    <h2 mat-dialog-title>GPS Track Settings</h2>

    <div class="mr-15">
        <button mat-icon-button
                [matTooltip]="'Reset to defaults'"
                (click)="reset()"
                [disabled]="isDefault()"
        >
            <mat-icon>restart_alt</mat-icon>
        </button>
    </div>
</div>

<mat-dialog-content class="mat-typography">

    <div class="flex-row justify-content-space-between align-items-center mb-15">
      <div class="config-label-wrapper">
        <div class="config-label text-bolder">
          GPS Track Style
        </div>
        <div class="config-label">
          Change the appearance of all live GPS tracks on the map
        </div>
      </div>

      <app-line-style-editor [routeStyle]="data.styleActive"
                             [editOpacity]="false"
                             [editWidth]="false"
      >
      </app-line-style-editor>
    </div>

    <div class="flex-row justify-content-space-between align-items-center mb-15">
      <div class="config-label-wrapper">
        <div class="config-label text-bolder">
          Include recently ended shifts
        </div>
        <div class="config-label">
          Show recent shifts that are no longer active
        </div>
      </div>

      <div class="config-form">
        <mat-slide-toggle
          [hideIcon]="true"
          class="mat-small"
          [(ngModel)]="data.showRecent"
        ></mat-slide-toggle>
      </div>
    </div>

    @if (data.showRecent) {
      <div class="flex-row justify-content-space-between align-items-center mb-15 indent">
        <div class="config-label-wrapper">
          <div class="config-label text-bolder">
            Lookback duration
          </div>
          <div class="config-label">
            Display shifts on the map that have ended within the last
          </div>
        </div>

        @if (configuration) {
          <div class="config-form">
            <mat-form-field style="width: 150px">
              <mat-select [(ngModel)]="data.timeLimit" placeholder="" panelWidth="150">
                @for (hour of hours; track hour) {
                  <mat-option [value]="hour">{{ hour }} hour@if (hour > 1) { <span>s</span> }
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        }
      </div>

      <div class="flex-row justify-content-space-between align-items-center mb-15 indent">
        <div class="config-label-wrapper">
          <div class="config-label text-bolder">
            Ended shift track style
          </div>
          <div class="config-label">
            Sets the appearance of all recently ended shifts
          </div>
        </div>

        <app-line-style-editor [routeStyle]="data.styleRecent"
                               [editOpacity]="false"
                               [editWidth]="false"
        >
        </app-line-style-editor>
      </div>
    }

</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-button color="accent" [mat-dialog-close]="data" cdkFocusInitial>Save</button>
</mat-dialog-actions>
